import React from 'react';
import BooksForm from './BooksForm';
import { Button } from 'react-bootstrap';
import './BooksForm.css';

export default function BooksPreview(props) {
  const { bookDetails, setBookDetails, viewOnly, handleClose, dispMsg, handleGoBack } = props;

  return (
    <div className="bookspreview-container">
      {/* Verification Notice Banner */}
      <div className="bookspreview-banner">
        <div className="d-flex align-items-start gap-3 flex-grow-1">
          <div className="bookspreview-banner-icon">
            <i className="bi bi-shield-check"></i>
          </div>
          <div className="flex-grow-1">
            <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-1">
              <div className="fw-bold text-dark fs-6">
                {dispMsg || "Bibliographic Record Verification"}
              </div>
              {handleGoBack && (
                <Button
                  variant="outline-primary"
                  size="sm"
                  className="fw-semibold px-3 py-1 shadow-sm d-inline-flex align-items-center gap-1"
                  onClick={handleGoBack}
                  title="Return to form and edit details"
                >
                  <i className="bi bi-arrow-left me-1"></i> Back to Edit Details
                </Button>
              )}
            </div>
            <div className="small text-muted">
              Please review the cataloguing details, classification, and shelf assignment below before saving to the library database.
            </div>
            <div className="d-flex flex-wrap gap-2 mt-2">
              <span className="bookspreview-summary-pill">
                <i className="bi bi-upc text-primary"></i> Accession #{bookDetails?.autoGenerate ? 'Auto (Assigned on Save)' : (bookDetails?.accessionNo || 'N/A')}
              </span>
              <span className="bookspreview-summary-pill">
                <i className="bi bi-bookmark text-success"></i> Call No: {bookDetails?.bookClassificationNo || 'N/A'}
              </span>
              <span className="bookspreview-summary-pill">
                <i className="bi bi-tag text-warning"></i> {bookDetails?.bookCategory || 'General'}
              </span>
              <span className="bookspreview-summary-pill">
                <i className="bi bi-geo-alt text-danger"></i> {bookDetails?.bookLocation || 'Periodical / Main Stack'}
              </span>
              <span className="bookspreview-summary-pill">
                <i className="bi bi-files text-purple"></i> {bookDetails?.bookCopies || 1} {Number(bookDetails?.bookCopies) === 1 ? 'Copy' : 'Copies'}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Render structured presentation view */}
      <BooksForm
        bookDetails={bookDetails}
        setBookDetails={setBookDetails}
        viewOnly={true}
        handleClose={handleClose}
      />
    </div>
  );
}
